export default [
  {
    id: 1,
    name: {
      en: "Breakfast",
      nl: "Ontbijt"
    },
    iconId: "cereal",
    start: 6
  },
  {
    id: 2,
    name: {
      en: "Morning snack",
      nl: "Ochtend break"
    },
    iconId: "food",
    start: 10
  },
  {
    id: 3,
    name: {
      en: "Lunch",
      nl: "Middageten"
    },
    iconId: "sandwich",
    start: 12
  },
  {
    id: 4,
    name: {
      en: "Afternoon snack",
      nl: "Middag break"
    },
    iconId: "meal",
    start: 14
  },
  {
    id: 5,
    name: {
      en: "Dinner",
      nl: "Avondeten"
    },
    iconId: "pasta",
    start: 17
  },
  {
    id: 6,
    name: {
      en: "Evening snack",
      nl: "Avond snack"
    },
    iconId: "lunch",
    start: 20
  },
  {
    id: 7,
    name: {
      en: "Snack",
      nl: "Tussendoortje"
    },
    iconId: "snack",
    start: 23
  },
  {
    id: 8,
    name: {
      en: "Thought",
      nl: "Gedachte"
    },
    iconId: "logo",
    start: 0
  }
];
